export const shadows = {
  md: '0px 4px 20px rgba(0, 0, 0, 0.1)',
}
